<template>
	<div class="search-iCard">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="el-right">
						<el-form
							ref="SearchIDardList"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
						>
							<el-form-item>
							<el-date-picker
								v-model="dateTime"
								type="datetimerange"
								format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								range-separator="-"
								:default-time="['00:00:00', '23:59:59']"
								:start-placeholder="$t('searchProductProfit.start')"
								:end-placeholder="$t('searchProductProfit.end')"
							>
							</el-date-picker>
							</el-form-item>
							<el-form-item prop="name">
								<el-input
									v-model="search.name"
									:placeholder="$t('searchIDard.name')"
									@input="onSubmit"
								></el-input>
							</el-form-item>
							<el-form-item prop="type">
								<el-input
									v-model="search.type"
									:placeholder="$t('searchIDard.type')"
									@input="onSubmit"
								></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('SearchIDardList')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchICard",
	props: {
		search: Object,
	},
	data() {
		return {
			dateTime: "",
		};
	},
	methods: {
		importICard() {
			this.dialogImportICard = true;
		},
		exportICard() {},
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endDate = this.dateTime[1];
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.dateTime = "";
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="scss">
.search-iCard {
	.el-upload--text,
	.el-upload-dragger {
		width: 100%;
	}
	.result {
		margin-top: 10px;
		color: var(--vtm-crit);
		max-height: 60px;
	}
}
</style>
